module.exports = __webpack_public_path__ + "img/p4.a3637d6f.png";